/**
 * Date helpers that always work in the user's LOCAL timezone.
 *
 * Why: `new Date(y, m, d).toISOString().slice(0, 10)` is timezone-dependent.
 * In Atlantic/Madeira (UTC+1 during WEST / summer), local midnight becomes
 * the previous day in UTC, so the ISO string is off by one. That made
 * `cell.iso` for the visual day "23" resolve to "2026-05-22", which meant
 * a booking scheduled for May 23rd was rendered on the cell labelled "24".
 *
 * Always use these helpers for grid-day ISO strings or "today" markers.
 */
export function toLocalIso(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayLocalIso() {
  return toLocalIso(new Date());
}
